// extracted by mini-css-extract-plugin
export var bgDark = "bbq-contact-component-module--bg-dark--3xRNa";
export var block = "bbq-contact-component-module--block--FnyFi";
export var subAttention = "bbq-contact-component-module--sub-attention--1CCfJ";
export var phone = "bbq-contact-component-module--phone--kV4qK";
export var flex = "bbq-contact-component-module--flex--2Ainb";
export var flexHorizontal = "bbq-contact-component-module--flex-horizontal--3DcTi";